import React from 'react';
import _ from 'lodash';
import * as Urls from 'src/constants/EndpointUrls';
import styles from './withSetupNeeded.scss';
import {useTranslation} from 'react-i18next'

const withSetupNeeded = title => Child => ({ notCompletedSetting, ...rest }) => {
  if (_.isEmpty(notCompletedSetting)) {
    return <Child {...rest} />;
  }
  const { t } = useTranslation();
  return (
    <div className={styles.nolist}>
      <p>
        {t(`components.WithSetupNeeded.${title}`)}
        <br />
        {t('components.WithSetupNeeded.please_complete_the_setup_from_the')}
        <a href={Urls.DASHBOARD_SHOW} className="u-txt-link">
          {t('components.SideMenu.SideMenu.dashbord')}
        </a>{t('components.WithSetupNeeded.to_complete')}
      </p>
    </div>
  );
};

export default withSetupNeeded;
